import Question from '@evidentid/ido-lib/interfaces/Question';

import FileField from '@/fields/FileField';
import type { IdoStore } from '@/store/interfaces/IdoStore';
import { AttributesValues } from '@/store/interfaces/RawIdoActions';
import { coiInputAttributeRegex } from '@/utils/insuranceAttributes';

export default class CoiScanField extends FileField {
    private coiInputAttributes: Question[] = [];

    protected override prepareData(store: IdoStore): Promise<any> | null {
        this.coiInputAttributes =
            store.questions.filter((question) => coiInputAttributeRegex.test(question.attrType));
        return null;
    }

    public override async encode(question: Question, value: File[]): Promise<AttributesValues> {
        const pages = await this.buildPages(value);

        return this.coiInputAttributes.reduce((o, question) =>
            Object.assign(o, {
                [question.attrType]: {
                    shareWith: question.shareWith || null,
                    value: {
                        $objectType: 'CapturedDocument',
                        content: pages,
                        description: null,
                        title: null,
                    },
                },
            }), {});
    }
}
